module.exports = __webpack_public_path__ + "static/media/upload.a518f587.svg";


//////////////////
// WEBPACK FOOTER
// ./src/documentUpload/upload.svg
// module id = 1926
// module chunks = 0